import { defineStore } from 'pinia'

const parseJwt = (token) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

const getToken = () => {
  const rawToken = ('; ' + document.cookie).split('; token=').pop().split(';')[0]
  if (rawToken) {
    return parseJwt(rawToken)
  }
  return null
}

const getRoles = (data) => {
  return data?.
    resource_access?.
    infinity?.
    roles || []
}

const hasRole = (data, role) => {
  return getRoles(data).includes(role)
}

const hasUniverseRole = (data) => {
  for (const role of getRoles(data)) {
    if (role.startsWith('universe-')) {
      return true
    }
  }
  return false
}

export const useAuthStore = defineStore('auth', {
  getters: {
    data () {
      return getToken()
    },
    isLoggedIn () {
      return !!getToken()
    },
    isDev () {
      return hasRole(getToken(), 'developer')
    },
    isMultiverse () {
      return hasRole(getToken(), 'multiverse')
    },
    isInfinity () {
      return hasRole(getToken(), 'infinity')
    },
    canCreate () {
      return this.isInfinity ||
        this.isMultiverse ||
        hasUniverseRole(getToken())
    },
    readOnly () {
      const roles = getRoles(getToken())
      // no roles, only has an account
      if (roles.length === 0) {
        return true
      }
      // has only the dev role
      if (roles.length === 1 && this.isDev) {
        return true
      }

      return false
    },
    hasUniverse: () => {
      return (universeName) => hasRole(getToken(), `universe-${universeName}`)
    },
    hasApp: () => {
      return (universeName, appName) => {
        console.log('hasrole', getToken(), `app-${universeName}-${appName}`)
        return hasRole(getToken(), `app-${universeName}-${appName}`)
      }
    },
  },
})
